import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.qore = bracketIndenting()
